export const tagsConstants = {
    TAGS_LIST_REQUEST: 'TAGS_LIST_REQUEST',
    TAGS_LIST_SUCCESS: 'TAGS_LIST_SUCCESS',
    TAGS_LIST_ERROR: 'TAGS_LIST_ERROR',
    TAGS_SEARCH_REQUEST: 'TAGS_SEARCH_REQUEST',

    TAGS_ADD_REQUEST : 'TAGS_ADD_REQUEST',
    TAGS_ADD_SUCCESS : 'TAGS_ADD_SUCCESS',
    TAGS_ADD_FAILURE :'TAGS_ADD_FAILURE',

    TAGS_DELETE_REQUEST : 'TAGS_DELETE_REQUEST',
    TAGS_DELETE_SUCCESS : 'TAGS_DELETE_SUCCESS',
    TAGS_DELETE_FAILURE : 'TAGS_DELETE_FAILURE',


    ACTIVE_TAGS_GET_REQUEST : 'ACTIVE_TAGS_GET_REQUEST',
    ACTIVE_TAGS_GET_SUCCESS : 'ACTIVE_TAGS_GET_SUCCESS',
    ACTIVE_TAGS_GET_FAILURE : 'ACTIVE_TAGS_GET_FAILURE',


};
